import { DerivedAvailabilityStatusInternal } from '@commerce-product-webcomponents/sdk';
import { DerivedAvailabilityStatusComponentType } from './enums';

export type StockStatusComponentPropsTypes = {
  derivedAvailabilityStatus?: string;
  showSubText?: boolean;
  dateSubText?: string;
  stockStatusType?: DerivedAvailabilityStatusComponentType;
  firstAvailableFutureDate?: string;
  showPrefix?: boolean;
};

export type StockStatusTextPropsTypes = StockStatusComponentPropsTypes & {
  className?: string;
  subtext?: string;
};

export const bundleDerivedStockStatusPriority = [
  DerivedAvailabilityStatusInternal.Nla,
  DerivedAvailabilityStatusInternal.OutOfStock,
  DerivedAvailabilityStatusInternal.Nya,
  DerivedAvailabilityStatusInternal.Bo,
  DerivedAvailabilityStatusInternal.Pbo, // To be decided from backend
  DerivedAvailabilityStatusInternal.LowStock,
  DerivedAvailabilityStatusInternal.InStock,
];
